import {useMemo} from 'react'
import {TradeErrorHighlightLocationEnum} from '@colonist/game-mechanic-validators'
import {useGameStore} from '../../store/GameStoreContext'
import {CardEnum} from '@colonist/game-states'

export const useCardsToHighlight = (location: TradeErrorHighlightLocationEnum): CardEnum[] => {
    const tradeError = useGameStore((state) => state.gameTrade.tradeError)

    const cardsToHighlight = useMemo(() => {
        const tradeErrorHighlightCards = tradeError?.payload?.highlightCards?.cardsToHighlight ?? []
        const tradeErrorHighlightLocations = tradeError?.payload?.highlightCards?.locations ?? []
        if(tradeErrorHighlightLocations.includes(location)) {
            return tradeErrorHighlightCards
        }
        return []
    }, [tradeError, location])

    return cardsToHighlight
}
